const simulator = {
    bindings: {
    },
    templateUrl: '/modules/pis-tool/simulator/simulator.html',
    controller: 'SimulatorController',
};

angular
    .module('pis-tool.module')
    .component('simulator', simulator)
    .config(function ($stateProvider) {
        $stateProvider.state('pis.workspaces.simulator', {
            url: '/simulator',
            redirectTo: 'pis.workspaces.simulator.form',
            views: {
                'pisview@pis': 'simulator',
            },
        });
    });
